import { render, staticRenderFns } from "./Proveedor.vue?vue&type=template&id=1fd3a81c&scoped=true&"
import script from "./Proveedor.vue?vue&type=script&lang=js&"
export * from "./Proveedor.vue?vue&type=script&lang=js&"
import style0 from "./Proveedor.vue?vue&type=style&index=0&id=1fd3a81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3a81c",
  null
  
)

export default component.exports